import React from "react";
import ProfileThumbnailImage from "../../assets/images/edit-profile-thumbnail.svg";
import { Image } from "react-bootstrap";
import { format } from "date-fns";
import PhoneNumberFormat from "../PhoneNumberFormate/PhoneNumberFormate";

const BasicInformationCard = ({ profile = {} }) => {
  const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
  };
  return (
    <div className="profile-card py-22 px-16 d-flex flex-wrap flex-sm-nowrap align-items-start">
      <div className="text-center mx-33">
        <div className="profile-img rounded-circle overflow-hidden">
          <Image
            src={
              profile?.profile_image?.startsWith("/")
                ? process.env.REACT_APP_GALLERY_URL +
                profile?.profile_image
                : process.env.REACT_APP_GALLERY_URL +
                profile?.profile_image
            }
            alt={"Instructor"}
            className="w-100 h-100 object-fit-cover p-4 rounded-circle"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = ProfileThumbnailImage;
            }}
          />
        </div>
        <div className="profile-name text-lg fw-bold mt-21">
          {profile?.full_name || "Not Provided"}
        </div>
      </div>

      <div className="profile-info d-flex flex-grow-1 flex-wrap">
        <div className="info-block">
          <span className="text-base fw-semibold mb-12 d-block black-800">
            Email
          </span>
          <p className="ah-text-base fw-semibold mb-0">
            {profile?.email || "Not Provided"}
          </p>
        </div>

        <div className="info-block">
          <span className="text-base fw-semibold mb-12 d-block black-800">
            Phone Number
          </span>
          <p className="ah-text-base fw-semibold mb-0">
            <PhoneNumberFormat number={profile?.phone_number || "Not Provided"} type="national" />
          </p>
        </div>

        <div className="info-block">
          <span className="text-base fw-semibold mb-12 d-block black-800">
            Role
          </span>
          <p className="ah-text-base fw-semibold mb-0">
            {profile?.role || "Not Provided"}
          </p>
        </div>

        <div className="info-block">
          <span className="text-base fw-semibold mb-12 d-block black-800">
            Date Of Birth
          </span>
          <p className="ah-text-base fw-semibold mb-0">
            {isValidDate(profile?.date_of_birth)
              ? format(new Date(profile?.date_of_birth), "MM-dd-yyyy")
              : "Not Provided"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BasicInformationCard;
